module.exports = __webpack_public_path__ + "static/img/Power Engineering.95242f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applications/Power Engineering.jpg
// module id = J194
// module chunks = 1